import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/Auth.context";
import InformationDialog from "../component/base/dialog-body/Information.dialog";
import AppButton from "../component/base/AppButton.component";
import { TYPE } from "./Utils";
import HocPopup from "../hoc/hocPopup";
import { useAppContext } from "../context/App.context";
import { Paper, Typography } from "@mui/material";
import AutoLogoutDialog from "../component/base/dialog-body/AutoLogout.dialog";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
const AutoLogout = ({ children, logout_time, dialog }) => {
  let timer;
  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    if (open) {
      dialog({
        open: true,
        showButton: false,
        bodyType: TYPE.LOGOUT,

        body: <AutoLogoutDialog />,
      });
      localStorage.removeItem("user");
    }
  }, [open]);

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      events.forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });

      setIsOpen(true);
    }, logout_time * 60 * 1000);
  };

  const resetTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
  };

  useEffect(() => {
    events.forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  return children;
};

export default HocPopup(AutoLogout);
